(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pdp-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRcasaPdp(root) {
      if (!root || root.dataset.pdpInit) return;
      root.dataset.pdpInit = "true";

      var variantsEl = root.querySelector("[data-pdp-variants]");
      var labelsEl = root.querySelector("[data-pdp-labels]");
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
      var labels = labelsEl ? JSON.parse(labelsEl.textContent) : {};
      var currency = root.dataset.currency || "INR";
      var locale = root.dataset.locale || "en-IN";
      var threshold = parseInt(root.dataset.stockThreshold, 10) || 10;
      var formatter;
      try {
        formatter = new Intl.NumberFormat(locale, { style: "currency", currency: currency });
      } catch (e) {
        formatter = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" });
      }
      function money(cents) {
        return formatter.format(cents / 100);
      }

      var variantSelect = root.querySelector("[data-variant-select]");
      var priceEls = root.querySelectorAll("[data-price]");
      var compareEls = root.querySelectorAll("[data-compare-price]");
      var savingsWrap = root.querySelector("[data-savings]");
      var savingsAmount = root.querySelector("[data-savings-amount]");
      var savingsPct = root.querySelector("[data-savings-pct]");
      var saleBadge = root.querySelector("[data-sale-badge]");
      var discountPctEl = root.querySelector("[data-discount-pct]");
      var atcButtons = root.querySelectorAll("[data-add-to-cart]");
      var stockWrap = root.querySelector("[data-stock-wrap]");
      var stockCount = root.querySelector("[data-stock-count]");
      var stockFill = root.querySelector("[data-stock-fill]");

      function selectedOptions() {
        var values = [];
        root.querySelectorAll(".pdp-option").forEach(function (fieldset) {
          var checked = fieldset.querySelector("[data-option-value]:checked");
          if (checked) values.push(checked.value);
        });
        return values;
      }

      function findVariant(options) {
        return variants.find(function (v) {
          return v.options.length === options.length && v.options.every(function (o, i) {
            return o === options[i];
          });
        });
      }

      function updateVariant() {
        var options = selectedOptions();
        var variant = options.length ? findVariant(options) : variants[0];

        root.querySelectorAll(".pdp-option").forEach(function (fieldset) {
          var checked = fieldset.querySelector("[data-option-value]:checked");
          var out = fieldset.querySelector("[data-selected-value]");
          if (checked && out) out.textContent = checked.value;
        });

        if (!variant) {
          atcButtons.forEach(function (btn) {
            btn.disabled = true;
            var t = btn.querySelector("[data-atc-text]");
            if (t) t.textContent = labels.unavailable || "Unavailable";
          });
          return;
        }

        if (variantSelect) variantSelect.value = String(variant.id);

        priceEls.forEach(function (el) {
          el.textContent = money(variant.price);
        });

        var onSale = variant.compare_at_price > variant.price;
        compareEls.forEach(function (el) {
          el.hidden = !onSale;
          el.textContent = onSale ? money(variant.compare_at_price) : "";
        });
        if (savingsWrap) {
          savingsWrap.hidden = !onSale;
          if (onSale) {
            var save = variant.compare_at_price - variant.price;
            var pct = Math.round((save * 100) / variant.compare_at_price);
            if (savingsAmount) savingsAmount.textContent = money(save);
            if (savingsPct) savingsPct.textContent = pct;
            if (saleBadge) {
              saleBadge.hidden = false;
              if (discountPctEl) discountPctEl.textContent = pct;
            }
          } else if (saleBadge) {
            saleBadge.hidden = true;
          }
        }

        atcButtons.forEach(function (btn) {
          btn.disabled = !variant.available;
          var t = btn.querySelector("[data-atc-text]");
          if (t) t.textContent = variant.available ? labels.add_to_cart || "Add to cart" : labels.sold_out || "Sold out";
        });

        if (stockWrap) {
          var low = variant.inventory_managed && variant.available && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold;
          stockWrap.hidden = !low;
          if (low) {
            if (stockCount) stockCount.textContent = variant.inventory_quantity;
            if (stockFill) stockFill.style.width = Math.max(8, Math.round((variant.inventory_quantity * 100) / threshold)) + "%";
          }
        }

        if (variant.media_id) {
          var slide = root.querySelector('[data-gallery-slide][data-media-id="' + variant.media_id + '"]');
          if (slide) goToSlide(parseInt(slide.dataset.index, 10));
        }

        if (window.history && window.history.replaceState && root.dataset.url) {
          window.history.replaceState({}, "", root.dataset.url + "?variant=" + variant.id);
        }
      }

      root.querySelectorAll("[data-option-value]").forEach(function (input) {
        input.addEventListener("change", updateVariant);
      });

      // Run once on init so the price, ATC state, and stock bar are driven
      // by the same JS logic (and live JSON data) from the very first paint,
      // not just after a variant option is changed.
      if (variants.length) {
        updateVariant();
      }

      var track = root.querySelector("[data-gallery-track]");
      var slides = root.querySelectorAll("[data-gallery-slide]");
      var thumbs = root.querySelectorAll("[data-gallery-thumb]");

      function setActiveThumb(index) {
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle("is-active", parseInt(thumb.dataset.index, 10) === index);
        });
        slides.forEach(function (slide) {
          slide.setAttribute("aria-hidden", parseInt(slide.dataset.index, 10) === index ? "false" : "true");
        });
      }

      function goToSlide(index) {
        if (!track || !slides[index]) return;
        track.scrollTo({ left: slides[index].offsetLeft, behavior: "smooth" });
        setActiveThumb(index);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          goToSlide(parseInt(thumb.dataset.index, 10));
        });
      });

      if (track) {
        var scrollTimer;
        track.addEventListener("scroll", function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var index = Math.round(track.scrollLeft / track.clientWidth);
            setActiveThumb(Math.min(index, slides.length - 1));
          }, 80);
        }, { passive: true });

        track.addEventListener("mousemove", function (event) {
          var slide = event.target.closest("[data-gallery-slide]");
          if (!slide) return;
          var rect = slide.getBoundingClientRect();
          slide.style.setProperty("--zoom-x", ((event.clientX - rect.left) / rect.width) * 100 + "%");
          slide.style.setProperty("--zoom-y", ((event.clientY - rect.top) / rect.height) * 100 + "%");
        });
      }

      var qtyInput = root.querySelector("[data-qty-input]");
      var minus = root.querySelector("[data-qty-minus]");
      var plus = root.querySelector("[data-qty-plus]");
      function stepQty(delta) {
        if (!qtyInput) return;
        var value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, value + delta);
      }
      if (minus) minus.addEventListener("click", function () { stepQty(-1); });
      if (plus) plus.addEventListener("click", function () { stepQty(1); });
      if (qtyInput) {
        qtyInput.addEventListener("change", function () {
          var value = parseInt(qtyInput.value, 10);
          if (!value || value < 1) qtyInput.value = 1;
        });
      }

      // Copy-to-clipboard for offer badges that carry a discount code.
      root.querySelectorAll("[data-offer-code]").forEach(function (badge) {
        badge.addEventListener("click", function () {
          var code = badge.getAttribute("data-offer-code");
          if (!code) return;
          var done = function () {
            var span = badge.querySelector("span");
            if (!span) return;
            var original = span.textContent;
            span.textContent = "Copied ✓";
            setTimeout(function () { span.textContent = original; }, 1500);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(function () {});
          } else {
            var ta = document.createElement("textarea");
            ta.value = code;
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand("copy"); } catch (e) {}
            document.body.removeChild(ta);
            done();
          }
        });
      });

      // --- AJAX add to cart with loading spinner ---
      // Replaces the native form submit (which reloaded the whole page and
      // left the button looking frozen) with a fetch to /cart/add.js so we
      // can show a spinner, handle errors, and reveal the cart smoothly.
      var pdpForm = root.querySelector("form.pdp-form");
      var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : "/";
      var cartBusy = false;

      function setBtnLoading(btn, on) {
        if (!btn) return;
        btn.classList.toggle("is-loading", on);
        if (on) {
          btn.setAttribute("aria-busy", "true");
          if (!btn.querySelector(".pdp-btn__spinner")) {
            var s = document.createElement("span");
            s.className = "pdp-btn__spinner";
            s.setAttribute("aria-hidden", "true");
            btn.appendChild(s);
          }
        } else {
          btn.removeAttribute("aria-busy");
          var sp = btn.querySelector(".pdp-btn__spinner");
          if (sp) sp.remove();
        }
      }

      function flashBtnText(btn, message, revert) {
        if (!btn) return;
        var t = btn.querySelector("[data-atc-text]");
        if (!t) return;
        var original = t.textContent;
        t.textContent = message;
        if (revert) {
          setTimeout(function () { t.textContent = original; }, 1800);
        }
      }

      function addToCart(form, btn) {
        if (cartBusy) return;
        cartBusy = true;
        setBtnLoading(btn, true);

        fetch(routeRoot + "cart/add.js", {
          method: "POST",
          headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (res) {
            if (!res.ok) throw res.data;

            // Let any theme cart drawer / count bubble know the cart changed.
            document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
            fetch(routeRoot + "cart.js", { headers: { "Accept": "application/json" } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.querySelectorAll(".cart-count-bubble, [data-cart-count], .cart-count").forEach(function (el) {
                  var target = el.querySelector("span:not([aria-hidden])") || el;
                  target.textContent = cart.item_count;
                });
                document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
              })
              .catch(function () {})
              .then(function () {
                setBtnLoading(btn, false);
                if (btn) btn.classList.add("is-added");
                flashBtnText(btn, "Added ✓", false);
                // Navigate to the cart page (same destination as before, now with feedback).
                window.location.href = routeRoot + "cart";
              });
          })
          .catch(function (err) {
            setBtnLoading(btn, false);
            cartBusy = false;
            var msg = (err && (err.description || err.message)) || "Couldn't add";
            flashBtnText(btn, msg, true);
          });
      }

      if (pdpForm) {
        pdpForm.addEventListener("submit", function (event) {
          event.preventDefault();
          var submitter = (event.submitter && event.submitter.hasAttribute("data-add-to-cart"))
            ? event.submitter
            : root.querySelector("[data-add-to-cart]");
          addToCart(pdpForm, submitter);
        });
      }

      var stickyBar = root.querySelector("[data-sticky-bar]");
      var buyZone = root.querySelector("[data-buy-zone]");
      if (stickyBar && buyZone && "IntersectionObserver" in window) {
        var stickyObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            stickyBar.classList.toggle("is-visible", show);
            stickyBar.setAttribute("aria-hidden", show ? "false" : "true");
          });
        }, { threshold: 0 });
        stickyObserver.observe(buyZone);
      }

      var animated = root.querySelectorAll("[data-animate]");
      if ("IntersectionObserver" in window) {
        var revealObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              revealObserver.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
        animated.forEach(function (el) { revealObserver.observe(el); });
      } else {
        animated.forEach(function (el) { el.classList.add("is-visible"); });
      }
    }

    function initAll() {
      document.querySelectorAll("[data-rcasa-pdp]").forEach(initRcasaPdp);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initAll);
    } else {
      initAll();
    }
    document.addEventListener("shopify:section:load", initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
